// Recovered compiled webpack factory 75597. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "invalidateCacheBelowFlightSegmentPath", {
      enumerable: !0,
      get: function () {
        return function e(t, r, o) {
          let i = o.length <= 2,
            [s, l] = o,
            u = (0, n.createRouterCacheKey)(l),
            c = r.parallelRoutes.get(s);
          if (!c) return;
          let f = t.parallelRoutes.get(s);
          if (((f && f !== c) || ((f = new Map(c)), t.parallelRoutes.set(s, f)), i))
            return void f.delete(u);
          let d = c.get(u),
            p = f.get(u);
          p &&
            d &&
            (p === d &&
              ((p = {
                lazyData: p.lazyData,
                rsc: p.rsc,
                prefetchRsc: p.prefetchRsc,
                head: p.head,
                prefetchHead: p.prefetchHead,
                parallelRoutes: new Map(p.parallelRoutes),
              }),
              f.set(u, p)),
            e(p, d, (0, a.getNextFlightSegmentPath)(o)));
        };
      },
    }));
  let n = r(69190),
    a = r(16378);
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
